import script from "./VPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./VPagination.vue?vue&type=script&setup=true&lang=ts"

import "./VPagination.vue?vue&type=style&index=0&id=ae736a06&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae736a06"]])

export default __exports__